import { isAxiosError } from "axios";

/**
 * แปลง error ของขั้น "ตรวจไฟล์" (preview) เป็นข้อความที่แสดงคู่กับปุ่มเลือกไฟล์
 *
 * previewPurchaseOrderImport ปิด global toast ไว้โดยตั้งใจ: เกือบทุกสาเหตุเป็นเรื่อง
 * ของ "ไฟล์ที่เพิ่งเลือก" ไม่ใช่ของระบบ ผู้ใช้ต้องอ่านซ้ำได้ตรงจุดที่เลือกไฟล์
 * ไม่ใช่ toast ที่หายไปใน 5 วินาที
 *
 * backend ของกลุ่ม PO ตอบข้อความปฏิเสธเป็นภาษาไทยที่บอกสาเหตุจริงมาแล้ว
 * (ไฟล์ไม่ใช่ Excel / เชนยังไม่รองรับ / อ่านไฟล์ไม่ได้ / ไม่ใช่สิทธิ์ HO) จึงใช้
 * ข้อความของ backend ก่อนเสมอ แล้วค่อยถอยมาที่ข้อความกลางตาม status
 */

const FALLBACK_BY_STATUS: Record<number, string> = {
  400: "ไม่พบไฟล์ หรือไฟล์มีขนาดใหญ่เกินไป (สูงสุด 10MB)",
  403: "บัญชีนี้ไม่มีสิทธิ์นำเข้าไฟล์ PO",
  415: "ไฟล์ไม่รองรับ กรุณาเลือกไฟล์ .xlsx หรือ .xls เท่านั้น",
  422: "ไฟล์นี้อ่านเป็นรายการ PO ไม่ได้ กรุณาตรวจสอบว่าเป็นไฟล์ที่ดึงจากเว็บของเชน",
};

const NETWORK_MESSAGE =
  "ติดต่อเซิร์ฟเวอร์ไม่ได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่";

const UNEXPECTED_MESSAGE = "ตรวจไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";

/** รูปแบบ body ของ error ที่ backend ส่งกลับมา — ทุกคีย์เป็น unknown จนกว่าจะตรวจ */
interface ServerErrorBody {
  message?: unknown;
  error?: unknown;
  detail?: unknown;
}

const isServerErrorBody = (value: unknown): value is ServerErrorBody =>
  typeof value === "object" && value !== null;

const asText = (value: unknown): string | null =>
  typeof value === "string" && value.trim() !== "" ? value : null;

const serverMessageOf = (body: unknown): string | null => {
  if (!isServerErrorBody(body)) return null;
  return asText(body.message) ?? asText(body.error) ?? asText(body.detail);
};

export const resolveImportPreviewFailure = (error: unknown): string => {
  if (!isAxiosError(error)) return UNEXPECTED_MESSAGE;

  const response = error.response;
  if (!response) return NETWORK_MESSAGE;

  return (
    serverMessageOf(response.data) ??
    FALLBACK_BY_STATUS[response.status] ??
    `${UNEXPECTED_MESSAGE} (Error ${response.status})`
  );
};
